import React from 'react';

export const ProjectsGrid = ({ items, onAccess }) => {
  return (
    <section className="pt-4 pb-4 max-w-7xl mx-auto px-6">
      <div className="text-center mb-8">
        <p className="text-[9px] font-bold tracking-[0.25em] text-amber-600 uppercase mb-1 font-sans">Quick Access</p>
        <h2 className="text-2xl md:text-3xl font-serif font-medium text-slate-900 leading-none">Our Projects</h2>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {items.map(item => (
          <div
            key={item.id}
            onClick={() => onAccess(item)}
            className="group relative overflow-hidden rounded-xl aspect-[4/3] cursor-pointer shadow-sm hover:shadow-md transition-shadow"
          >
            <img
              src={require(`../../../assets/Images/${item.img}.jpg`)}
              alt={item.label}
              className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-black/0 group-hover:bg-black/45 transition-all duration-300 flex items-center justify-center">
              {/* <span className="text-white font-serif text-sm opacity-0 group-hover:opacity-100 transition-opacity duration-300 tracking-widest uppercase font-semibold">
                {item.label}
              </span> */}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};




